<template>
  <div class="box">

        <b-field label="Display Holding Quantity as:">
            <b-select v-model="selected" placeholder="Dollars Invested" @input="choiceCallback">
                <option value="dollars" key="dollars" :selected="selected === 'dollars'" >Dollars Invested</option>
                <option value="percentages" key="percentages" :selected="selected === 'percentages'">Percentages</option>
            </b-select>
        </b-field>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        selected: 'dollars' // or 'percentages'
      }
    },
    props: {
      dollarsOrPercentage: String,
      callback: Function,
    },
    methods: {
      choiceCallback(event) {
        this.callback.call(this, event);
      },
      preselectedCallback(choice) {
        this.selected = choice;
        this.callback.call(this, choice);
      },
    },
    watch: {
      dollarsOrPercentages() {
        this.selected = this.dollarsOrPercentage;
      }
    },
    created() {
      this.selected = this.dollarsOrPercentage;
    }
  }
</script>

<style scoped>
.round {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid rgba(0, 0, 0, 0.25);
}

button.round.selected {
  border: 4px solid #000;
}
</style>
